export class BaseElement {

    /**
     * @var
     */
    id: number;

    /**
     * @var
     */
    name: string;

    /**
     * @var
     */
    width: number;

    /**
     * @var
     */
    length: number;

    /**
     * @var
     */
    height: number;

    /**
     * @var
     */
    model3d: string;

    constructor(id: number, name: string, width: number, length: number, height: number, model3d: string) {
        this.name = name;
        this.id = id;
        this.width = width;
        this.height = height;
        this.length = length;
        this.model3d = model3d;
    }
}



// WEBPACK FOOTER //
// ./src/app/base-element.ts